<template>
  <div class="d-flex align-center">
    <v-menu
      offset-y
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          text
          class="text-body-1"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon small class="pr-2">fa-filter</v-icon>
          Filtrar
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item>
          <v-list-item-content style="padding-bottom: 0">
            <span>Data inicial de cronograma</span>
            <v-menu
              ref="minDataMenu"
              v-model="minDataMenu"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="minFormattedDate"
                  dense
                  readonly
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar-blank"
                  clearable
                  @click:clear="() => handleMinDataFaturamentoCronograma('')"
                />
              </template>
              <v-date-picker
                no-title
                style="min-width: 100%"
                color="primary"
                @input="handleMinDataFaturamentoCronograma"
                :value="minDataFaturamentoCronograma"
                locale="pt-br"
              />
            </v-menu>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content style="padding-bottom: 0">
            <span>Data final de cronograma</span>
            <v-menu
              ref="maxDataMenu"
              v-model="maxDataMenu"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="maxFormattedDate"
                  readonly
                  dense
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar-blank"
                  clearable
                  @click:clear="() => handleMaxDataFaturamentoCronograma('')"
                />
              </template>
              <v-date-picker
                no-title
                style="min-width: 100%"
                color="primary"
                @input="handleMaxDataFaturamentoCronograma"
                :value="maxDataFaturamentoCronograma"
                locale="pt-br"
              />
            </v-menu>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <span>Numero do Lote</span>
            <template>
              <v-text-field
                v-model="filterNumeroLote"
                dense
                outlined
                @change="handleFilterNumeroLote"
              />
            </template>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <span>Valor pendente máximo</span>
            <template>
              <v-text-field
                prefix="R$"
                :value="valorPendenteLte || valorPendentePagamento"
                dense
                outlined
                clearable
                :rules="[
                  v => !((/[^\w\s.]/gi.test(v)) || (/[a-zA-Z]/.test(v))) || 'Utilize apenas números',
                  v => (/^\-?[0-9]+(?:\.[0-9]{1,2})?$/.test(v)) || 'Formato inválido'
                ]"
                @change="handleValorPendenteLte"
              />
            </template>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-checkbox
              style="padding: 0; margin: 0"
              @change="handleValorPendenteOnly"
              :value="!valorPendenteOnly"
              color="primary"
              hide-details
            />
            <span style="max-width: fit-content">Exibir lotes sem valor pendente</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-tooltip right v-if="(minDataFaturamentoCronograma || maxDataFaturamentoCronograma || filterNumeroLote || valorPendenteLte)">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          icon
          @click="handleClearFilters"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon small class="pr-2">far fa-times-circle</v-icon>
        </v-btn>
      </template>
      <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
        Remover filtros
      </span>
    </v-tooltip>
  </div>
</template>

<script>

export default {
  data () {
    return {
      minDataMenu: false,
      minDataModal: false,
      maxDataMenu: false,
      maxDataModal: false,
    }
  },
  props: {
    minDataFaturamentoCronograma: String,
    maxDataFaturamentoCronograma: String,
    valorPendenteOnly: Boolean,
    filterNumeroLote: String,
    valorPendenteLte: Number,
    page: Number,
    valorPendentePagamento: Number
  },
  computed: {
    minFormattedDate () {
      return this.formatDate(this.minDataFaturamentoCronograma || '')
    },
    maxFormattedDate () {
      return this.formatDate(this.maxDataFaturamentoCronograma || '')
    }
  },
  methods: {
    formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },
    handleMinDataFaturamentoCronograma (newValue) {
      this.resetPage()
      return this.$emit('update:minDataFaturamentoCronograma', newValue)
    },
    handleMaxDataFaturamentoCronograma (newValue) {
      this.resetPage()
      return this.$emit('update:maxDataFaturamentoCronograma', newValue)
    },
    handleValorPendenteOnly (newValue) {
      this.resetPage()
      return this.$emit('update:valorPendenteOnly', !newValue)
    },
    handleFilterNumeroLote (newValue) {
      this.resetPage()
      return this.$emit('update:filterNumeroLote', newValue)
    },
    handleValorPendenteLte (newValue) {
      this.resetPage()
      return this.$emit('update:valorPendenteLte', newValue)
    },
    handleClearFilters () {
      this.resetPage()
      return this.$emit('clearFilters')
    },
    resetPage () {
      return this.$emit('update:page', 1)
    },
  }
}
</script>
